import Button from 'app/shared/components/button/Button';
import { PadExpand } from 'app/shared/components/misc';
import React from 'react';
import { useMovePage } from '../../business-profile-utils';

type Props = {
  onBack?: () => unknown;
  onSubmit?: () => unknown;
  isSubmit?: boolean;
  sending?: boolean;
  isIndividual?: boolean;
  locationCount?: boolean;
};
export default function BottomPageAndSubmitActions({
  onBack,
  onSubmit,
  isSubmit,
  sending,
  isIndividual,
  locationCount,
}: Props): JSX.Element {
  const { prevPage } = useMovePage();
  return (
    <>
      <PadExpand secondary />
      <Button
        type="submit"
        pending={sending}
        onClick={onSubmit}
        disabled={locationCount}
      >
        {isSubmit ? 'Save' : 'Next Page'}
      </Button>

      <Button
        variant="outlined"
        onClick={() => {
          onBack?.();
          prevPage(isIndividual);
        }}
      >
        Previous Page
      </Button>
    </>
  );
}
